import { useEffect } from "react";
import { DashboardLayout } from "../../../components/organisms/Layout";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import BusinessPanel from "./Business/BusinessPanel";
import AnalyticsPanel from "./Analytics/AnalyticsPanel";
import RBACPanel from "./RBAC/RBACPanel";
import Groups from "./Groups/Groups";
import AlertsPanel from "./Alerts/AlertsPanel";
import { MessageBroadcast } from "./MessageBroadcast";
import Notifications from "./Notifications/Notifications";
import JobSeekerDashboard from "./JobSeekerDashboard/JobSeekerDashboard";
import { QuestionsPanel } from "./Questions";
import { VideoPromptPanel } from "./VideoPrompt";

/** Tab names must match the panels rendered below and sidebar links. */
const CONTROL_PANEL_TABS = [
  "Business",
  "Analytics",
  "RBAC",
  "Job Seeker Analytics",
  "Message Broadcast",
  "Hospitality Groups",
  "Alerts",
  "Notifications",
  "Questions",
  "Video Prompt",
];

const AdminControlPanel = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = searchParams.get("tab");
  const resolvedTab =
    tabFromUrl && CONTROL_PANEL_TABS.includes(tabFromUrl)
      ? tabFromUrl
      : "Business";
  const [openTab, setOpenTab] = useState(resolvedTab);

  useEffect(() => {
    document.title = "HeyHire Admin-Control-Panel";

    const nextTab =
      tabFromUrl && CONTROL_PANEL_TABS.includes(tabFromUrl)
        ? tabFromUrl
        : "Business";

    setOpenTab(nextTab);

    if (nextTab !== tabFromUrl) {
      setSearchParams({ tab: nextTab }, { replace: true });
    }
  }, [tabFromUrl, setSearchParams]);

  const handleTabClick = (key) => {
    setSearchParams({ tab: key });
    setOpenTab(key);
  };

  return (
    <DashboardLayout>
      <div className="w-full">
        <div className="mx-auto flex flex-col">
          <main className="flex-1">
            <div className="relative mx-auto">
              <div>
                <div className="mb-6">
                  <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-gray-900">
                    Control Panel
                  </h1>
                  <p className="mt-1 text-sm text-gray-600">
                    Manage {openTab} settings and configurations
                  </p>
                </div>

                {/* Tab Content */}
                <div>
                  {openTab === "Business" && (
                    <div
                      key="Business"
                      className="transition-opacity duration-150 ease-linear"
                    >
                      <BusinessPanel callback={handleTabClick} />
                    </div>
                  )}

                  {openTab === "Analytics" && (
                    <div
                      key="Analytics"
                      className="transition-opacity duration-150 ease-linear"
                    >
                      <AnalyticsPanel callback={handleTabClick} />
                    </div>
                  )}

                  {openTab === "RBAC" && (
                    <div
                      key="RBAC"
                      className="transition-opacity duration-150 ease-linear"
                    >
                      <RBACPanel callback={handleTabClick} />
                    </div>
                  )}

                  {openTab === "Job Seeker Analytics" && (
                    <div
                      key="Job Seeker Analytics"
                      className="transition-opacity duration-150 ease-linear data-[te-tab-active]:block"
                    >
                      <JobSeekerDashboard callback={handleTabClick} />
                    </div>
                  )}

                  {openTab === "Message Broadcast" && (
                    <div
                      key="Payment Logs"
                      className="transition-opacity duration-150 ease-linear data-[te-tab-active]:block"
                    >
                      <MessageBroadcast />
                    </div>
                  )}

                  {openTab === "Hospitality Groups" && (
                    <div
                      key="Hospitality Groups"
                      className="transition-opacity duration-150 ease-linear data-[te-tab-active]:block"
                    >
                      <Groups />
                    </div>
                  )}

                  {openTab === "Alerts" && (
                    <div
                      key="RBAC"
                      className="transition-opacity duration-150 ease-linear"
                    >
                      <AlertsPanel callback={handleTabClick} />
                    </div>
                  )}

                  {openTab === "Notifications" && (
                    <div
                      key="Notifications"
                      className="transition-opacity duration-150 ease-linear"
                    >
                      <Notifications callback={handleTabClick} />
                    </div>
                  )}

                  {openTab === "Questions" && (
                    <div
                      key="Questions"
                      className="transition-opacity duration-150 ease-linear"
                    >
                      <QuestionsPanel callback={handleTabClick} />
                    </div>
                  )}

                  {openTab === "Video Prompt" && (
                    <div
                      key="Video Prompt"
                      className="transition-opacity duration-150 ease-linear"
                    >
                      <VideoPromptPanel callback={handleTabClick} />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AdminControlPanel;
